















import { Component, Vue, Prop, Inject, Watch } from "vue-property-decorator";
import { IContract, IContractProduct } from "@/models/contracts";
import { ICProdProvider } from "@/models/providers/contractProduct";
import { IProvisionProviderData } from "@/models/providers/provisioning";
import { AdminRoutes } from "@/data/enums/router";

@Component({
  components: {
    "cprod-header": () =>
      import(`@/components/app/global/client/contractProducts/cProdHeader.vue`),
    "cprod-messages": () =>
      import(`@/components/app/global/contractProducts/cProdMessages.vue`)
  }
})
export default class AdminClientContractProduct extends Vue {
  // Inject

  @Inject({ from: "contractProductProvider" })
  public readonly $cProdData!: () => ICProdProvider;

  @Inject({ from: "cProdProvProvider" })
  public readonly $cProdProvData!: () => IProvisionProviderData;

  // Props

  @Prop({ default: () => [] })
  public routes!: (vm: AdminClientContractProduct & any) => any[];

  @Prop({ required: true })
  public productId!: IContractProduct["id"];

  @Prop({ required: true })
  public contractId!: IContract["id"];

  // Computed

  public get cProdData() {
    return this.$cProdData();
  }

  public get cProdProvData() {
    return this.$cProdProvData();
  }

  public get cProdIds() {
    return {
      contractId: this.contractId,
      productId: this.productId
    };
  }

  // Watchers

  @Watch("cProdData.name", { immediate: true })
  public onNameChange(cProdName) {
    this.$store.commit("ui/setMetaProps", {
      cProdName: cProdName || this.$t("_.product")
    });
  }

  /**
   * @name onLoadingChange
   * @desc Here we monitor the loading state of the cProdProvider, and when
   * ready (and IF on the parent route), we determine where to redirect the
   * user to; either the cProd overview or setup view.
   */

  @Watch("cProdData.isLoading", { immediate: true })
  public async onLoadingChange(isLoading: boolean, wasLoading: boolean) {
    if ((wasLoading ?? true) && !isLoading && !!this.cProdData.contract) {
      if (this.$route?.name !== "admin__clientCProd") return;
      // Route to new location
      await this.$router
        .replace({
          name: this.cProdData.isAwaitingSetup
            ? AdminRoutes.CONTRACT_PRODUCT_SETUP
            : AdminRoutes.CONTRACT_PRODUCT_OVERVIEW,
          params: {
            doBusReload: false as any
          }
        })
        .catch(err => err);
      // Pop previous route from breadcrumb trail
      this.$store.commit("ui/popPreviousRoute");
    }
  }

  // Life-cycle methods

  public beforeDestroy() {
    this.$store.commit("ui/unsetMetaProps", ["cProdName"]);
  }
}
